/* src/modules/create_tutor/action_types.js */

export const addTutorsTypes = [
  'ADD_TUTORS',
  'ADD_TUTORS_SUCCESS',
  'ADD_TUTORS_FAIL',
];

export const CLEAR_ADDED_TUTORS = 'CLEAR_ADDED_TUTORS';



// WEBPACK FOOTER //
// ./src/modules/create_tutor/action_types.js